import { Pincode } from './pincode';

export class City {
    cityCode: string="";
    cityDesc: string="";
}